import { StyledTypography } from './StyledTypography'
import { SafeLink } from '@eidsivabredband/react-component-ui-package'
import { MouseEventHandler, ReactNode, RefObject } from 'react'

interface TypographyWithUrlsProps {
  contentref?: RefObject<any>
  children: ReactNode
  onClick?: MouseEventHandler<HTMLSpanElement>
}

function TypographyWithUrl({ children, contentref, onClick }: TypographyWithUrlsProps) {
  const text = children

  if (typeof text !== 'string') {
    return <StyledTypography>{text}</StyledTypography>
  }

  const urls = text.match(/(https?:\/\/[^\s]+)/g)
  const parts = text.split(/(https?:\/\/[^\s]+)/g)
  return (
    <StyledTypography ref={contentref} onClick={onClick}>
      {parts.map((part, index) => {
        if (urls && urls.includes(part)) {
          return (
            <SafeLink key={index} showInvalidUrlsAsText={true} href={part} rel="noopener noreferrer" target="_blank">
              {part}
            </SafeLink>
          )
        }
        return part
      })}
    </StyledTypography>
  )
}

export default TypographyWithUrl
